import React from 'react'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { Locale, Translation } from 'locale'
import { PositionsGrouping } from './rfqPanelUtils'

export const PositionsGroupingSelectbox = React.forwardRef(
  (props: Omit<SelectboxProps<PositionsGrouping, PositionsGrouping>, 'optionKeys'>, ref: React.Ref<Selectbox>) => {
    const { value, className, onUpdate } = props
    return (
      <Selectbox
        ref={ref}
        className={className}
        placeholder={Translation.SC_SELECT_A_GROUPING}
        optionKeys={[Translation.SC_GROUP_BY_ASSETS, Translation.SC_GROUP_BY_COUNTERPARTIES]}
        getOptionText={(option: PositionsGrouping) => Locale.translate(option)}
        value={value}
        onUpdate={onUpdate}
      />
    )
  }
)
